import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '../../store';
import { OverlayService } from '../../services/overlay.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import { NotificationService } from '../../services/notification.service';
import { SeoService } from '../../services/seo.service';
import { CmsService } from '../../services/cms.service';
import { MenuService } from '../../services/menu.service';
import { Title } from '@angular/platform-browser';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';
import { forkJoin, Subject, BehaviorSubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-plugin-loader-layout',
    templateUrl: './plugin-loader-layout.component.html',
    styleUrls: ['./plugin-loader-layout.component.scss']
})
export class PluginLoaderLayoutComponent implements OnInit, OnDestroy {
    title = 'public';
    overlays$ = this.store.select<any>('overlays');
    innerWidth$ = this.store.select<number>('innerWidth');
    deviceType$ = this.store.select<string>('deviceType');
    page;
    pageSnippets = [];
    mobileMenu$ = this.store.select<boolean>('mobileMenu');
    mobileMenuUser$ = this.store.select<boolean>('mobileMenuUser');
    hasLoaded = false;
    private destroy$ = new Subject();
    private contentLoaded$ = new BehaviorSubject<boolean>(false);

    constructor(
        private store: Store,
        private overlayService: OverlayService,
        public router: Router,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private notificationService: NotificationService,
        private seoService: SeoService,
        private cmsService: CmsService,
        private menuService: MenuService,
        private titleService: Title,
        private breadcrumbsService: BreadcrumbsService,
    ) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntil(this.destroy$)
        ).subscribe((event: NavigationEnd) => {
            let activeRoute = event.url.replace(/^\/|\/$/g, '');
            if (activeRoute === '') {
                activeRoute = 'home';
            }
            if (activeRoute.charAt(0) === '?') {
                activeRoute = 'home';
            }
            forkJoin([
                this.cmsService.pages(),
                this.cmsService.pageSnippets(activeRoute.replace(/\//g, '-'))
            ]).subscribe(([pagesData, snippetData]) => {
                this.pageSnippets = snippetData;
                this.hasLoaded = true;
                this.getPageContent(activeRoute.replace(/\//g, '-'));
                this.contentLoaded$.next(true);
            });

            this.menuService.menuByRoute(activeRoute.replace(/\//g, '-'));
            this.overlayService.addLoadingSubject(this.contentLoaded$);
        });
    }

    ngOnInit(): void {
        this.cmsService.getSettings().subscribe();
        this.menuService.menuGroups();
    }

    getPageContent(route) {
        const routeToFind = route.split('?')[0];
        const pages = this.store.selectForLocal('pages');
        if (pages) {
            this.page = pages[routeToFind];
            if (this.page) {
                this.titleService.setTitle(this.page.metaTitle);
                this.setMetaTags(this.page);
                this.breadcrumbsService.changeBreadcrumb([{ text: this.page.name, route: [this.page.route] }]);
                this.breadcrumbsService.changeFloatingState(this.page.floatingBreadcrumb);
            }
        }
    }

    setMetaTags(data) {
        this.seoService.updateTitle(data.metaTitle);
        this.seoService.addMetaTag('description', data.metaDescription);
        this.seoService.createLinkForCanonicalURL();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
